import React from 'react';
import withAuthorization from "../../../services/Authorization";
import {injectIntl} from "react-intl";
import LoadingIndicator from "../../common/loading/LoadingIndicator";
import connect from "react-redux/es/connect/connect";
import {Pagination, Table} from "antd";
import BoldText from "../../common/text/BoldText";
import CarInfoModal from "./CarInfoModal";
import CarCreationModal from "./CarCreationModal";
import Constants from "../../../services/Constants";
import SAPopconfirm from "../../common/confirmation/SAPopconfirm";

const Column = Table.Column;

class CarParkTable extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rentals: [],
      showRentalInfo: false,
      currentPage: 1,
      currentPageSize: 10,
      currentSort: {}
    }
  }

  componentDidMount() {
    this.props.dispatchFetchRentalVehicles({page: this.state.currentPage-1, size: this.state.currentPageSize});
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.fetchRentalVehicles && nextProps.fetchRentalVehicles.rentals) {
      const {rentals} = nextProps.fetchRentalVehicles;
      this.setState({rentals});
    }
  };

  onModalClose = (modalName) => {
    this.setState({[modalName]: false});
  };

  onRowSelection = (selectedCar) => {
    this.setState({selectedCar, showRentalInfo: true})
  };

  onRowDelete = (row, event) => {
    this.props.dispatchDeleteRentalVehicle({id: row.vehicleId});

    // prevents rental information modal from open
    event.stopPropagation();
  };

  onRowEdit = (row, event) => {
    this.setState({selectedCar: row});
    this.onShowRentalCreation();

    // prevents rental information modal from open
    event.stopPropagation();
  };

  onRentalAdd = () => {
    this.setState({selectedCar: undefined});
    this.onShowRentalCreation();
  };

  onShowRentalCreation = () => {
    this.props.showRentalModal();
  };

  onHideRentalCreation = () => {
    this.props.hideRentalModal();
  };

  onPageOptionsChange = (page, size) => {
    const {currentSort} = this.state;
    this.setState({
      currentPage: page,
      currentPageSize: size
    });

    const sort = currentSort.columnKey ? [currentSort.columnKey, Constants.SORT_OPTIONS[currentSort.order].value] : [];
    this.props.dispatchFetchRentalVehicles({page: page-1, size: size, sort});
  };

  onTableChange = (pagination, filters, sorter) => {
    const {currentPage, currentPageSize} = this.state;
    const sort = sorter.columnKey ? [sorter.columnKey, Constants.SORT_OPTIONS[sorter.order].value] : [];

    this.props.dispatchFetchRentalVehicles({page: currentPage-1, size: currentPageSize, sort});
    this.setState({currentSort: sorter});
  };

  render() {
    const {intl:{formatMessage}, fetchRentalVehicles, saveRentalVehicle: {showModal}, deleteRentalVehicle: {error}} = this.props;
    const {currentPage, currentSort, rentals, selectedCar, showRentalInfo} = this.state;
    const {totalElements} = fetchRentalVehicles;

    return (
      <section className="box">
        <header className="box-heading">
          <h2 className="box-heading__title">
            {formatMessage({id:'section.car-park-management.title'})}
          </h2>
          <div className="box-heading__right">
            <button onClick={this.onRentalAdd} type="primary" className="btn btn-sm btn-primary">{formatMessage({id:'action.add'})}</button>
          </div>
        </header>
        <div className="box__body">
          {(fetchRentalVehicles.loading) ? (
            <LoadingIndicator/>
          ) : (
            <div className="table-wrapper__body">
              {error && error.code &&
                <div className="alert alert--error">
                  {formatMessage({id: error.code})}
                </div>
              }
              <Table className="table overview-table"
                     dataSource={rentals}
                     loading={fetchRentalVehicles.loading}
                     rowKey={'vin'}
                     pagination={false}
                     onRow={(record) => ({onClick: () => this.onRowSelection(record)})}
                     onChange={this.onTableChange}
              >
                <Column
                  title={formatMessage({id: 'vehicle.category'})}
                  dataIndex="category"
                  key="category"
                  className="overview-table__category"
                  render={text => {
                    return formatMessage({id: `mobility.${text}`});
                  }}
                  sorter={true}
                  sortOrder={currentSort.columnKey === 'category' ? currentSort.order : ''}
                />
                <Column
                  title={formatMessage({id: 'vehicle.vin'}) + ' / ' + formatMessage({id: 'vehicle.serialNumber'})}
                  dataIndex="vin"
                  key="vin"
                  className="overview-table__vin-plate"
                  render={text => text.length === 17 ? <BoldText text={text} boldEndCharacters={7}/> : text}
                  sorter={true}
                  sortOrder={currentSort.columnKey === 'vin' ? currentSort.order : ''}
                />
                <Column
                  title={formatMessage({id:'vehicle.make'})}
                  dataIndex="brand"
                  key="brand"
                  className="overview-table__brand"
                  sorter={true}
                  sortOrder={currentSort.columnKey === 'brand' ? currentSort.order : ''}
                />
                <Column
                  title={formatMessage({id:'vehicle.model'})}
                  dataIndex="model"
                  key="model"
                  className="overview-table__model"
                  sorter={true}
                  sortOrder={currentSort.columnKey === 'model' ? currentSort.order : ''}
                />
                <Column
                  title={formatMessage({id:'vehicle.modelCode'})}
                  dataIndex="modelCode"
                  key="modelCode"
                  className="overview-table__model-code"
                  sorter={true}
                  sortOrder={currentSort.columnKey === 'modelCode' ? currentSort.order : ''}
                />
                <Column
                  title={formatMessage({id:'vehicle.plate'})}
                  dataIndex="licensePlate"
                  key="licensePlate"
                  className="overview-table__vin-plate"
                  sorter={true}
                  sortOrder={currentSort.columnKey === 'licensePlate' ? currentSort.order : ''}
                />
                <Column
                  title={formatMessage({id:'vehicle.gearbox'})}
                  dataIndex="gearbox"
                  key="gearbox"
                  className="overview-table__gearbox"
                  render={text => {
                    return text ? formatMessage({id: `vehicle.gearbox.${text}`}) : text
                  }}
                  sorter={true}
                  sortOrder={currentSort.columnKey === 'gearbox' ? currentSort.order : ''}
                />
                <Column
                  render={(text, row) => (
                    <a onClick={(event) => this.onRowEdit(row, event)}>{formatMessage({id: 'action.edit'})}</a>
                  )}
                />
                <Column
                  render={(text, row) => (
                    <SAPopconfirm action="delete" onConfirm={e => this.onRowDelete(row, e)} onCancel={e => e.stopPropagation()}>
                      <a onClick={e => e.stopPropagation()}>{formatMessage({id: 'action.delete'})}</a>
                    </SAPopconfirm>
                  )}
                />
              </Table>

              {showRentalInfo &&
                <CarInfoModal onModalClose={() => this.onModalClose("showRentalInfo")} visible={showRentalInfo} selectedCar={selectedCar}/>
              }
              {showModal &&
                <CarCreationModal onModalClose={this.onHideRentalCreation} visible={showModal} selectedCar={selectedCar}/>
              }
            </div>
          )}

          <footer className="table-wrapper__footer">
            <Pagination className="pagination" current={currentPage}
                        defaultCurrent={1} onChange={this.onPageOptionsChange}
                        showSizeChanger onShowSizeChange={this.onPageOptionsChange}
                        pageSizeOptions={["10", "25", "50", "100"]} defaultPageSize={10}
                        total={totalElements}
            />
          </footer>
        </div>
      </section>
    )
  }
}

const mapStateToProps = state => ({
  fetchRentalVehicles: state.fetchRentalVehicles,
  saveRentalVehicle: state.saveRentalVehicle,
  deleteRentalVehicle: state.deleteRentalVehicle
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchRentalVehicles: (parameters, sorter) => dispatch({type: 'FETCH_RENTAL_VEHICLES.REQUEST', parameters, sorter}),
  dispatchDeleteRentalVehicle: (parameters) => dispatch({type: 'DELETE_RENTAL_VEHICLE.REQUEST', parameters}),
  showRentalModal: () => dispatch({type: 'SHOW_RENTAL_MODAL'}),
  hideRentalModal: () => dispatch({type: 'HIDE_RENTAL_MODAL'})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(CarParkTable), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
